import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';
const avatarTones = ['bg-coral-wash text-coral-deep', 'bg-gold-wash text-gold-deep', 'bg-leaf-wash text-leaf-deep', 'bg-navy/10 text-navy'];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="bg-paper" data-id="element-348" data-mp="3azt57ofmmxjh">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-349" data-mp="36ziphk218srf">
        <SectionHeading id="testimonials-title" title="Christians Are Choosing a Simpler Way to Start Sharing Their Faith" data-id="element-350" data-mp="31zwap66k34gi" />
        <ul className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-351" data-mp="2x004d0adz0xs">
          {testimonials.map((t, i) => <li key={t.name} className="flex flex-col rounded-2xl bg-white p-7 shadow-card ring-1 ring-cream-line sm:p-8" data-id="element-352" data-mp="2s2i4s0i9dy2g" data-mpi={i}>
              <QuoteIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-353" data-mp="v85alzo35h3u" />
              <p className="mt-4 font-display text-2xl leading-tight text-navy" data-id="element-354" data-mp="qa3ot6z9z3oo">“{t.headline}”</p>
              <blockquote className="mt-3 flex-1 leading-relaxed text-ink-soft" data-id="element-355" data-mp="h5or9fhq4e9j">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-cream-line pt-5" data-id="element-356" data-mp="m5b3blltfogr">
                <span className={`flex h-11 w-11 items-center justify-center rounded-full font-display text-xl ${avatarTones[i % avatarTones.length]}`} data-id="element-357" data-mp="78k3xcc56cr5">
                  {t.name.charAt(0)}
                </span>
                <div data-id="element-358" data-mp="zxh9qfz62h30">
                  <p className="font-extrabold text-navy" data-id="element-359" data-mp="zx7tvl7u5qb1">{t.name}</p>
                  <p className="text-sm text-ink-mute" data-id="element-360" data-mp="14uhf0oo6zft2">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}